import React, { useRef } from 'react';
import { SectionReveal } from './ui/SectionReveal';
import { useLanguage } from '../context/LanguageContext';
import { ChefHat, Wind, ThermometerSun, DoorClosed, Lightbulb, Car, Package, Frame, ShieldCheck, Blinds, ChevronLeft, ChevronRight } from 'lucide-react';
export function QualitiesSection() {
  const {
    t
  } = useLanguage();
  const scrollRef = useRef<HTMLDivElement>(null);
  const qualities = [{
    icon: ChefHat,
    text: t.qualities.items[0]
  }, {
    icon: Wind,
    text: t.qualities.items[1]
  }, {
    icon: ThermometerSun,
    text: t.qualities.items[2]
  }, {
    icon: DoorClosed,
    text: t.qualities.items[3]
  }, {
    icon: Lightbulb,
    text: t.qualities.items[4]
  }, {
    icon: Car,
    text: t.qualities.items[5]
  }, {
    icon: Package,
    text: t.qualities.items[6]
  }, {
    icon: Frame,
    text: t.qualities.items[7]
  }, {
    icon: ShieldCheck,
    text: t.qualities.items[8]
  }, {
    icon: Blinds,
    text: t.qualities.items[9]
  }];
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  return <SectionReveal id="calidades" className="relative overflow-hidden" data-id="element-327" data-mp="2g88asn3xsulw">
      {/* Background photo */}
      <div className="absolute inset-0 z-0" data-id="element-328" data-mp="2kzq8n2anyf2n">
        <img src="https://cdn.magicpatterns.com/uploads/pXbDNz6pTQR7EzR1KjWJeB/20260302_-_16_-_Homefort_-_Las_Chafiras-3.jpg" alt="Interior de vivienda Aneto con cocina equipada" className="w-full h-full object-cover" data-id="element-329" data-mp="2l1jhmo8r1bdt" />
      </div>

      <div className="container relative z-10 mx-auto px-6 md:px-12" data-id="element-330" data-mp="1xb70cmrm62ak">
        <div className="max-w-3xl mb-10" data-id="element-331" data-mp="229gx31szlaya">
          <span className="inline-block text-nature text-sm font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-332" data-mp="228fmszjsoshm">
            {t.nav.calidades}
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-navy mb-6 leading-tight" data-id="element-333" data-mp="31idea74wq9x">
            {t.qualities.title}
          </h2>
          <p className="text-navy/70 text-lg leading-relaxed" data-id="element-334" data-mp="3u94jsal8n6uh">
            {t.qualities.subtitle}
          </p>
        </div>

        {/* Carousel Container */}
        <div className="relative group" data-id="element-335" data-mp="qs4k9y5ek4ic">
          {/* Navigation Arrows */}
          <button onClick={() => scroll('left')} className="absolute left-0 top-1/2 -translate-y-1/2 -ml-4 md:-ml-6 z-20 w-10 h-10 md:w-12 md:h-12 bg-white hover:bg-sand text-navy rounded-full flex items-center justify-center shadow-lg transition-colors" aria-label="Anterior" data-id="element-336" data-mp="lsi7fpthkqa2">
            <ChevronLeft className="w-5 h-5 md:w-6 md:h-6" data-id="element-337" data-mp="32hos424tqtxe" />
          </button>

          <button onClick={() => scroll('right')} className="absolute right-0 top-1/2 -translate-y-1/2 -mr-4 md:-mr-6 z-20 w-10 h-10 md:w-12 md:h-12 bg-white hover:bg-sand text-navy rounded-full flex items-center justify-center shadow-lg transition-colors" aria-label="Siguiente" data-id="element-338" data-mp="2xi2g1w0qfjq6">
            <ChevronRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-339" data-mp="1m0gch2ka423h" />
          </button>

          {/* Scrollable Track */}
          <div ref={scrollRef} className="flex gap-4 overflow-x-auto snap-x snap-mandatory hide-scrollbar pb-4 pt-2 px-2" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-340" data-mp="1qs8137jvjxqz">
            {qualities.map((quality, index) => <div key={index} className="flex-none w-[280px] sm:w-[320px] snap-start flex items-center gap-4 p-5 rounded-xl bg-white/90 backdrop-blur-sm border border-white shadow-sm hover:bg-white transition-colors" data-id="element-341" data-mp="25pgzumbic3sq" data-mpi={index}>
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-nature/15 flex items-center justify-center" data-id="element-342" data-mp="fday0tquv80m">
                  <quality.icon className="w-6 h-6 text-navy" data-id="element-343" data-mp="3g5w9dr8dpd8f" />
                </div>
                <span className="text-navy font-medium text-sm sm:text-base leading-tight" data-id="element-344" data-mp="3c53xsrc1aw8z">
                  {quality.text}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </SectionReveal>;
}